<template>
  <div style="padding: 20px;overflow-x:hidden">
    <div class="row bottom-sapce">
      <div class="col-md-3">
        <div class="form-group">
          <label for="startDate">{{ $t("labels.startDate") }}</label>
          <date-picker v-model="filters.startDate" width="100%" :appendToBody="true" format="DD/MM/YYYY"
            :lang="$i18n.locale"></date-picker>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="endDate">{{ $t("labels.endDate") }}</label>
          <date-picker v-model="filters.endDate" width="100%" :appendToBody="true" format="DD/MM/YYYY"
            :lang="$i18n.locale"></date-picker>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="aggregate">{{ $t("labels.aggregate") }}</label>
          <select name="aggregate" class="form-control" id="aggregate" v-model="filters.aggregate">
            <option value="month">{{ $t("labels.month") }}</option>
            <option value="day">{{ $t("labels.day") }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <button class="btn btn-success" @click.prevent="getStatistics">{{ $t("labels.filter") }}</button> - 
          <a href="" @click.prevent="exportStats" class="btn btn-success">{{ $t("labels.exportChart") }}</a>
          <small class="ml-1">( {{ $i18n.t('labels.maxPrintInterval') }} )</small>
        </div>
      </div>
    </div>
    <hr />
    <div class="row bottom-space" v-if="seizureData[1]">
      <div class="col-md-12" ref="gch2">
        <h4>{{ $t("labels.numSeizuresByType") }}</h4>
        <GChart :settings="{ packages: ['corechart', 'table', 'map', 'timeline'], language: $store.getters.userLang }"
          type="ColumnChart" :data="seizureData" :options="seizureOptions" isStacked="true" width="auto"
          ref="seizureChart"/>  
        <GChart :settings="{ packages: ['corechart', 'table', 'map', 'timeline'], language: $store.getters.userLang }" :style="{'opacity': 0, 'position': 'absolute'}"
          type="ColumnChart" :data="seizureData" :options="seizureOptionsForPrint" isStacked="true" width="auto" @ready="updateSeizureChartImg"
          ref="seizureChartHidden"/>    
        <div id="seizureChartDiv" style="display:none"> 
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <h4>{{ $t("labels.numSeizuresByType") }}</h4>
        <h4>{{ $t("labels.noDataForChart") }}</h4>
        <hr />
      </div>
    </div>
    <div class="row" v-if="timeBandMonths[1]">
      <div class="col-md-12">
        <h4>{{ $t("labels.numSeizuresByTimeBands") }}</h4>
        <table class="table table-responsive-sm text-center" id="timeBandsTable" ref="timeBandsTable" :data-months-column="differenceInMonths">
          <thead>
            <tr>
              <th v-for="(month, index) in timeBandMonths" :key="index">
                {{ month }}
              </th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(rowData, rowIndex) in timeBandDataXMonth" :key="rowIndex">
              <td v-for="(columnData, columnIndex) in rowData" :key="columnIndex">
                <template v-if="columnIndex == 0">
                    {{ columnData }}
                </template>
                <template v-else>
                  <table style="width: 100%;">
                    {{ columnData }}
                    <br>
                    <template v-if="columnData != '-'">
                      <span style="color:red">V:{{ Object.values(timeBandExtraDataXMonth[columnIndex - 1].extra_data[rowData[0]])[0].awake }}</span><br>
                      S:{{ Object.values(timeBandExtraDataXMonth[columnIndex - 1].extra_data[rowData[0]])[0].lazy }}
                    </template>
                  </table>
                </template>
                <!-- <template v-if="columnIndex == 0">
                  <table style="width: 100%;">
                    <tbody>
                      <tr>
                        <td style="font-size:14px">
                          {{ columnData }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Sveglio
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Dormiente
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
                <template v-else>
                  <table style="width: 100%;">
                    <tbody>
                      <tr>
                        <td>
                          {{ columnData }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {{ Object.values(timeBandExtraDataXMonth[columnIndex - 1].extra_data[rowData[0]])[0].awake }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                           {{ Object.values(timeBandExtraDataXMonth[columnIndex - 1].extra_data[rowData[0]])[0].lazy }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <h4>{{ $t("labels.numSeizuresByTimeBands") }}</h4>
        <h4>{{ $t("labels.noDataForChart") }}</h4>
        <hr />
      </div>
    </div>
    <div class="row" v-if="therapyData[1]">
      <div class="col-md-12">
        <h4>{{ $t("labels.therapyHistory") }}</h4>
        <table class="table table-responsive-sm text-center table-striped" id="timeBandsTable" ref="therapyDataTable" :data-months-column="differenceInMonths">
          <thead>
            <tr>
              <th v-for="(month, index) in therapyData[0]" :key="index">
                {{ month }}
              </th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(rowData, rowIndex) in therapyData.slice(1)" :key="rowIndex">
              <td v-for="(columnData, columnIndex) in rowData" :key="columnIndex">
                <template v-if="columnIndex == 0">
                  {{ translateDrugName(columnData) }}
                  <br>
                  <span style="font-size:10px">{{ formatDate(columnData.firstAppearance, 'L') }}</span>
                </template>
                <template v-else>
                  {{ columnData ? columnData.quantity : '-' }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <h4>{{ $t("labels.therapyHistory") }}</h4>
        <h4>{{ $t("labels.noDataForChart") }}</h4>
        <hr />
      </div>
    </div>
    <div class="row" v-if="drugStopped[1]">
      <div class="col-md-12">
        <h4>{{ $t("labels.drugStoppedTimeline") }}</h4>
        <table class="table table-responsive-sm text-center table-striped" id="timeBandsTable" ref="drugStoppedTable" :data-months-column="differenceInMonths">
          <thead>
            <tr>
              <th v-for="(month, index) in drugStopped[0]" :key="index">
                {{ month }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rowData, rowIndex) in drugStopped.slice(1)" :key="rowIndex">
              <td v-for="(columnData, columnIndex) in rowData" :key="columnIndex">
                <template v-if="columnIndex == 0">
                  {{ translateDrugName(columnData) }}
                </template>
                <template v-else>
                  {{ columnData ? columnData.numberOfUsage : '-' }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <h4>{{ $t("labels.drugStoppedTimeline") }}</h4>
        <h4>{{ $t("labels.noDataForChart") }}</h4>
        <hr />
      </div>
    </div>
    <div class="row" v-if="growthChanges[1]">
      <div class="col-md-12">
        <h4>{{ $t("labels.growthHistory") }}</h4>
        <table class="table table-responsive-sm text-center table-striped" id="timeBandsTable" ref="growthChangeTable" :data-months-column="differenceInMonths">
          <thead>
            <tr>
              <th v-for="(month, index) in growthChanges[0]" :key="index">
                {{ month }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rowData, rowIndex) in growthChanges.slice(1)" :key="rowIndex">
              <td v-for="(columnData, columnIndex) in rowData" :key="columnIndex">
                <template v-if="columnIndex == 0">
                  {{ $i18n.t(`labels.${columnData}`) }}
                </template>
                <template v-else>
                  {{ columnData }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <h4>{{ $t("labels.growthHistory") }}</h4>
        <h4>{{ $t("labels.noDataForChart") }}</h4>
        <hr />
      </div>
    </div>
    <div class="row" v-if="events.length">
      <div class="col-md-12">
        <h4>{{ $t("labels.eventsInPeriod") }}</h4>
        <table class="table table-responsive-sm">
          <thead>
            <th>{{ $t("labels.type") }}</th>
            <th>{{ $t("labels.typeValue") }}</th>
            <th>{{ $t("labels.start") }}</th>
            <th>{{ $t("labels.end") }}</th>
          </thead>
          <tbody>
            <tr v-for="event in events" :key="event._id">
              <td>{{ $t(`lovTypes.${event.type}`) }}</td>
              <td>
                {{ event.typeValue && event.typeValue.name && event.typeValue.name[$i18n.locale] ? event.typeValue.name[$i18n.locale] : event.typeValue && event.typeValue.name ? event.typeValue.name['en'] : '' }}
              </td>
              <td>{{ formatDate(event.startDate) }}</td>
              <td>{{ formatDate(event.endDate) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <h4>{{ $t("labels.eventsInPeriod") }}</h4>
        <h4>{{ $t("labels.noEventsInPeriod") }}</h4>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import _ from 'lodash'
  import StatisticsService from '@/services/statistics'

  const download = require('downloadjs')
  export default {
    data() {
      return {
        patient: this.$store.getters.selectedPatient,
        exportSeizureChart: false,
        exportTimelineChart: true,
        filters: {
          startDate: moment().startOf('month').subtract(3,'month').format('YYYY-MM-DD'),
          endDate: moment().endOf('month').format('YYYY-MM-DD'),
          status: 'none',
          blockedWithDrugs: false,
          aggregate: 'month'
        },
        timeLineOptions: {
          width: '100%',
          height: 400,
          chart: {
            title: 'Timeline'
          },
          timeline: {
            colorByRowLabel: true
          }
        },
        seizureChartSvg: null,
        seizureOptions: {
          isStacked: true,
          height: 400,
          legend: {
            position: 'top',
            maxLines: 3
          },
          chart: {
            bar: {
              groupWidth: '75%'
            },
            isStacked: true
          },
          chartArea: {
            'left': "6.7%",
            'width': '95%',
            'height': '50%',
          },
          vAxis: {
            format: '0',
            viewWindowMode: 'explicit',
            viewWindow: {
              min: 0,
              interval: 1
            }
          },
          responsive: true,
          explorer: {
            actions: ['dragToZoom', 'rightClickToReset']
          }
        },
        seizureOptionsForPrint: {
          isStacked: true,
          height: 400,
          width: 2560,
          legend: {
            position: 'top',
            maxLines: 3
          },
          chart: {
            bar: {
              groupWidth: '75%'
            },
            isStacked: true
          },
          vAxis: {
            format: '0',
            viewWindowMode: 'explicit',
            viewWindow: {
              min: 0,
              interval: 1
            }
          },
          chartArea: {
            'width': '98%',
            'height': '50%',
          },
          responsive: true,
          explorer: {
            actions: ['dragToZoom', 'rightClickToReset']
          }
        },
        timeBandOptions: {
          isStacked: true,
          height: 300,
          legend: {
            position: 'top',
            maxLines: 3
          },
          chart: {
            bar: {
              groupWidth: '75%'
            },
            isStacked: true
          },
          vAxis: {
            format: '0',
            viewWindowMode: 'explicit',
            viewWindow: {
              min: 0,
              interval: 1
            }
          },
          explorer: {
            actions: ['dragToZoom', 'rightClickToReset']
          }
        },
        drugStoppedOptions: {
          width: '100%',
          height: 300,
          chart: {
            title: 'Timeline'
          },
          timeline: {
            colorByRowLabel: true
          }
        },
        growthChartOptions: {
          width: '100%',
          height: 500,
          chart: {
            title: 'Growth changes'
          }
        },
        growthChanges: [],
        drugStopped: [],
        therapyData: [],
        seizureData: [],
        timeBandData: [],
        events: [],
        timeBandMonths: [],
        timeBandDataXMonth: [],
        timeBandExtraDataXMonth: [],
      }
    },
    computed: {
      differenceInMonths: function() {
        return Math.ceil(moment(this.filters.endDate).diff(this.filters.startDate, 'months', true))
      },
      pdfStyle: function() {
        return `
            body {
              width: 25cm;
            }
            svg {
              margin-left: 2.0cm;
              width: 20cm;
            }
            table {
              border-collapse: collapse;
              table-layout: fixed;
              font-size: 8pt;
              width: 22cm;
            }
            table thead tr {
              font-weight: bold;
              height: 0.5cm;

            }

            table thead th:first-child{
              width: 2cm!important;
            }

            table thead tr th {
              background: #eaa24e !important;
            }

            table tr td {
              padding: 0.5cm 0.6cm;
              text-align: center;
            }

            table tr td:first-child{
              text-align: left;
              text-transform: uppercase;
              padding: 0.2cm;
            }

            table  tr{
              border-bottom: 0.05cm solid #eaa24e;
            }

            table  tr:nth-child(even) {
              background: #f6f6f6;
            }

            table  tr:nth-child(odd) {
              background: #ffffff;
            }
            table, tr, td, th, tbody, thead, tfoot {
                page-break-inside: avoid !important;
            }
        `
      }
    },
    methods: {
      seizureChartHTML: function () {
        try {
          return this.seizureChartSvg.outerHTML
        } catch (e) {
          return ''
        }
      },
      timeBandsTableHTML: function () {
        try {
          return this.$refs.timeBandsTable.outerHTML
        } catch (e) {
          return ''
        } 
      },
      therapyDataTableHTML: function () {
        try {
          return this.$refs.therapyDataTable.outerHTML
        } catch (e) {
          return ''
        } 
      },
      drugStoppedTableHTML: function () {
        try {
          return this.$refs.drugStoppedTable.outerHTML
        } catch (e) {
          return ''
        } 
      },
      growthChangeTableHTML: function () {
        try {
          return this.$refs.growthChangeTable.outerHTML
        } catch (e) {
          return ''
        } 
      },
      formatDate(date, format) {
        let value = format
        if (value === undefined) {
          value = 'L'
        }
        return moment(date).format(value)
      },
      formatTimestamp(date, format) {
        let value = format
        if (value === undefined) {
          value = 'L HH:mm'
        }
        return moment.unix(date).format(value)
      },
      translateDrugName: function(drugNameObj) {
        console.log(drugNameObj)
        if (drugNameObj && drugNameObj[this.$i18n.locale]) {
          return drugNameObj[this.$i18n.locale]
        }else {
          return drugNameObj['en']
        }
      },
      extracTimeBandMonthExtraData: function (monthIndex, timeBandLabel) {
        try {
          let obj = Object.values(this.timeBandExtraDataXMonth[monthIndex].extra_data[timeBandLabel])[0]
          let result = ''
          result = '( ' + this.$i18n.t('labels.awake').slice(0, 3) + ': ' + obj.awake
          result += ' | ' + this.$i18n.t('labels.lazy').slice(0, 3) + ': ' + obj.lazy + ' )'
          return result
        } catch (e) {
          console.log(e)
          return ''
        }
      },
      updateSeizureChartImg: function() {
        let context = this
        try {
          setTimeout(() => {
            if (!context.$refs.seizureChart || !context.$refs.seizureChart.chartObject) {
              context.seizureChartSvg = null;
            }
            document.getElementById('seizureChartDiv').innerHTML = '<img class="img-print" src="' + context.$refs.seizureChart.chartObject.getImageURI() + '">';
            var svg = $(context.$refs.seizureChartHidden.$el).find('svg').clone();
            svg.attr('viewBox', '0 0 2545 400');
            context.seizureChartSvg = svg[0];
          },300)
        }catch(e){}

      },
      exportStats: async function () {
        let htmlToPdf = ``;
        
        htmlToPdf += `<html>
            <style>
               ${this.pdfStyle}
            </style>
            <body>
                Export - ${moment(this.filters.startDate).format('L HH:mm')} - ${moment(this.filters.endDate).format('L HH:mm')}
                <div id="seizures-chart">
                  <h2>${this.$t("labels.numSeizuresByType")}</h2>
                  ${this.seizureChartHTML()}
                </div>
                <p style="page-break-before: always">
                <div id="seizures-chart">
                  <h2>${this.$t("labels.numSeizuresByTimeBands")}</h2>
                  ${this.timeBandsTableHTML()}
                </div>
                <p style="page-break-before: always">
                <div id="seizures-chart">
                  <h2>${this.$t("labels.therapyHistory")}</h2>
                  ${this.therapyDataTableHTML()}
                </div>
                <p style="page-break-before: always">
                <div id="seizures-chart">
                  <h2>${this.$t("labels.drugStoppedTimeline")}</h2>
                  ${this.drugStoppedTableHTML()}
                </div>
                <p style="page-break-before: always">
                <div id="seizures-chart">
                  <h2>${this.$t("labels.growthHistory")}</h2>
                  ${this.growthChangeTableHTML()}
                </div>
            </body>
          </html>
        `

        let result = await StatisticsService.exportToPdfFromMobile(htmlToPdf)
        const content = result.headers['content-type']
        var blob = new Blob([result.data], {type: "application/pdf"});
        var objectUrl = URL.createObjectURL(blob);
        
        download(result.data, `${this.$t("labels.seizurecharts")}-${moment(new Date()).format('L HH:mm')}`, content)
      },
      getStatistics: async function (lang) {

        let result = await StatisticsService.seizureGraphForMobile(this.patient._id, lang, this.filters)
        let context = this
        if (result) {
          this.seizureData = [...result.data.seizures.dataSet]

          this.seizureOptions = Object.assign({}, this.seizureOptions, {
            vAxis: {
              format: '0',
              viewWindowMode: 'explicit',
              viewWindow: {
                max: result.data.seizures.maxValue,
                min: 0,
                interval: 1
              }
            }
          })

          this.timeBandData = [...result.data.timeBands.dataSet]
          this.timeBandOptions = Object.assign({}, this.timeBandOptions, {
            vAxis: {
              format: '0',
              viewWindowMode: 'explicit',
              viewWindow: {
                max: result.data.timeBands.maxValue,
                min: 0,
                interval: 1
              }
            }
          })

          let rows = []
          _.each(context.timeBandData.slice(0, 1)[0], (timeBandLabel) => {
            rows.push([timeBandLabel])
          })

          context.timeBandMonths = []
          context.timeBandDataXMonth = []
          context.timeBandExtraDataXMonth = []

          context.timeBandMonths.push('')
          await _.each(context.timeBandData.slice(1), (tbd) => {
            context.timeBandMonths.push(tbd[0])
            let dataForMonth = []
            _.each(rows, (row, index) => {
              row.push(tbd[index + 1])
            })
            context.timeBandExtraDataXMonth.push(tbd[tbd.length - 1])
          })
          context.timeBandDataXMonth = rows

          this.events = result.data.events.dataSet

          this.therapyData = result.data.therapies.dataSet

          this.drugStopped = result.data.drugStopped.dataSet

          this.growthChanges = result.data.growthHistory.dataSet


          // // let drugStoppedData = []
          // // await _.forEach(result.data.drugStopped.dataSet.slice(1), item => {
          // //   let current = [item[0], item[1], new Date(item[2]), new Date(item[3])]
          // //   drugStoppedData.push(current)
          // // })

          // // this.drugStopped = [result.data.drugStopped.dataSet[0], ...drugStoppedData]
          // // let uniqueStoppedDrugNames = [...new Set(this.drugStopped.map(function (t) {
          // //   return t[0]
          // // }))]
          // let ga = []
          // let historyStart = new Date(this.filters.startDate)
          // let historyEnd = new Date(this.filters.endDate)
          // console.log('growthHistory ', this.patient.growthHistory)
          // let filteredHistory = this.patient.growthHistory.filter(function (item) {
          //   return new Date(item.dateOfChange) >= historyStart && new Date(item.dateOfChange) <= historyEnd
          // })
          // await _.forEach(filteredHistory, item => {
          //   let currentGrowth = {
          //     dateOfChange: new Date(item['dateOfChange']),
          //     height: item['height'],
          //     weight: item['weight']
          //   }
          //   ga.push(currentGrowth)
          // })
          // this.growthChanges = ga
          this.updateSeizureChartImg()
        }
      }
    },
    mounted: async function () {
      let lang = this.$route.query.lang || this.$store.getters.userLang
      await this.getStatistics(lang)
      this.$i18n.locale = lang;
      moment.locale(lang)
      // console.log(this.timeBandData)
    }
  }
</script>